import { FileSourceEnum } from '@systemeio/file-manager'
import { Checkbox, Hint } from '@systemeio/ui'
import {
  CourseEditApiInterface,
  CourseEditInterface,
} from 'modules/courses/courses/types/course-interface'
import SettingsSectionHeading from 'modules/profile/components/settings-section-heading'
import { useState } from 'react'
import { ImageUploaderWithPreviewImage } from 'shared/components/file-uploader/image-uploader-with-preview-image'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { DataFile } from 'shared/types/datafile-type'

interface CertificationSettingsProps {
  onChange: React.Dispatch<React.SetStateAction<CourseEditInterface>>
  tempEditState: CourseEditInterface
  courseData: CourseEditApiInterface
}

export default function CertificationSettings({
  onChange,
  tempEditState,
  courseData,
}: CertificationSettingsProps) {
  const { t } = useLocoTranslation()
  const [certificateLogoImage, setCertificateLogoImage] = useState(
    courseData?.certificateLogo?.path,
  )
  const [signatureImage, setSignatureImage] = useState(courseData?.signature?.path)

  const handleCertificateLogoChange = (file: DataFile) => {
    onChange(prev => ({ ...prev, certificateLogo: file.id }))
    setCertificateLogoImage(file.path)
  }

  const handleSetSignature = (file: DataFile) => {
    onChange(prev => ({ ...prev, signature: file.id }))
    setSignatureImage(file.path)
  }

  return (
    <div className="flex flex-col gap-5">
      <SettingsSectionHeading>
        {t('dashboard.course.certification_settings')}
      </SettingsSectionHeading>
      <Checkbox
        value={!!tempEditState.issueCertificateUponCompletion}
        onChange={val => onChange(prev => ({ ...prev, issueCertificateUponCompletion: val }))}
        label={t('dashboard.course.issue_certificate_upon_completion_title')}
      />
      <div className="flex gap-7 lg:gap-10">
        <ImageUploaderWithPreviewImage
          label={
            <Hint label={t('dashboard.course.certificate_logo_popover_title')}>
              {t('dashboard.course.certificate_logo_title')}
            </Hint>
          }
          value={certificateLogoImage ? { path: certificateLogoImage } : null}
          onRemove={() => {
            onChange(prev => {
              return {
                ...prev,
                certificateLogo: undefined,
              }
            })
            setCertificateLogoImage('')
          }}
          onSelect={handleCertificateLogoChange}
          source={FileSourceEnum.Membership}
        />
        <ImageUploaderWithPreviewImage
          label={
            <Hint label={t('dashboard.course.signature_popover_title')}>
              {t('dashboard.course.signature_title')}
            </Hint>
          }
          value={signatureImage ? { path: signatureImage } : null}
          onRemove={() => {
            onChange(prev => {
              return {
                ...prev,
                signature: undefined,
              }
            })
            setSignatureImage('')
          }}
          onSelect={handleSetSignature}
          source={FileSourceEnum.Membership}
        />
      </div>
    </div>
  )
}
